import { InsightsPageTemplate } from "@/components/templates/InsightsPageTemplate";
import { geoCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = geoCluster.insightPages.find(p => p.slug === "what-is-geo")!;
const relatedMoney = getRelatedMoneyPages("geo").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("geo").map(p => ({ title: p.title, slug: p.slug }));

export default function WhatIsGEOPage() {
  return (
    <InsightsPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
